"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REST_API_BASE_URL = void 0;
// DEV: https://api-staging.origyn.com
// PROD: https://api.origyn.com
exports.REST_API_BASE_URL = process?.env.REST_API_BASE_URL ?? 'https://api.origyn.com';
